import { useNavigate } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';


interface Props {
  title: string;
  subtitle: string;
  twoArrows?: boolean;
  subtitle1?: string;
  rutaEspecifica: string;
}

function TitleContainer({
  title,
  subtitle,
  twoArrows,
  subtitle1,
  rutaEspecifica,
}: Props) {
  const navigate = useNavigate();

  return (
    <>
      {twoArrows ? (
        <div className="mt-4">
          <div className="flex gap-4 items-center">
            <ArrowBackIcon
              fontSize="large"
              onClick={() => navigate(rutaEspecifica)}
              className="cursor-pointer"
            />
            <div className="flex flex-col">
              <p className="title">{title}</p>
              <p className="title">{subtitle1}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-4">
          <div className="flex gap-4 items-center">
            <ArrowBackIcon
              fontSize="large"
              onClick={() => navigate(rutaEspecifica)}
              className="cursor-pointer"
            />
            <p className="title">{title}</p>
          </div>

          <p className="subtitle">{subtitle}</p>
        </div>
      )}
    </>
  );
}

export default TitleContainer;
